import { IFormDataU } from "../../pages/user-stepper/UserStepper";
import InputComponent from "../../components/elements/InputComponent";
import ControlledSelectElement from "../../components/elements/ControlledSelectElement";
import ButtonComponent from "../../components/elements/ButtonComponent";
import { motion } from "framer-motion";
import { axiosPrivate } from "../../api/axios";
import customZ from "../../utils/setZodCustomMessages";
import {
  notEmptyDate,
  notEmptyField,
  nationalIdSchema,
} from "../../utils/customSchemas";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { childVariants } from "../../animation/RoutesAnimations";
import { useEffect, useState } from "react";
import Lottie from "react-lottie";
import animationData from "../../../src/jsons/LoadingBg.json";
import NotifAccordionComponent from "../../components/elements/NotifAccordionComponent";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFnsJalali } from "@mui/x-date-pickers/AdapterDateFnsJalali";
import { CalenderIcon } from "../../components/Icons";
import moment from "jalali-moment";
import FILL_REPRESENTATIVE_INFO, {
  LIST_REPRESENTATIVES,
  USER_UPDATE_REPRESENTATIVE_INFO,
} from "../../api/apiClient";

export interface relationType {
  relation: string;
  name: string;
}

export interface relationType_2 {
  relation_2: string;
  name: string;
}

const relationList: relationType[] = [
  {
    relation: "FAMILY",
    name: "بستگان",
  },
  {
    relation: "FRIENDS",
    name: "دوستان",
  },
  {
    relation: "COLLEAGUES",
    name: "همکاران",
  },
];

const relationList_2: relationType_2[] = [
  {
    relation_2: "FAMILY",
    name: "بستگان",
  },
  {
    relation_2: "FRIENDS",
    name: "دوستان",
  },
  {
    relation_2: "COLLEAGUES",
    name: "همکاران",
  },
];

const step4Schema = customZ.object({
  phone_number: notEmptyField,
  national_id: nationalIdSchema,
  birth_date: notEmptyDate,
  birth_date_2: notEmptyDate,
  first_name: notEmptyField,
  last_name: notEmptyField,
  relation: notEmptyField,
  phone_number_2: notEmptyField,
  national_id_2: nationalIdSchema,
  first_name_2: notEmptyField,
  last_name_2: notEmptyField,
  relation_2: notEmptyField,
});

function UserFormStep4({ formNo, setFormNo }: any) {
  const {
    handleSubmit,
    control,
    setValue,
    getValues,
    formState: { errors },
  } = useForm<IFormDataU>({
    resolver: (data, context, options) => {
      return zodResolver(step4Schema)(data, context, options);
    },
  });

  const access_token = localStorage.getItem("access_token");
  const [representativeInfo, setRepresentativeInfo] = useState<any>(undefined);
  const [hasValueBefor, setHasValueBefor] = useState<any>(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingContents, setIsLoadingContents] = useState<boolean>(false);
  const [editMode, setEditMode] = useState<boolean>(false);
  const [representativeIndex, setRepresentativeIndex] =
    useState<any>(undefined);

  const [dataFromOcr] = useState<any>(null);

  const getRepresentativeInfo = async () => {
    setIsLoadingContents(true);
    setIsLoading(true);
    try {
      const response = await axiosPrivate.get(
        LIST_REPRESENTATIVES,

        {
          headers: {
            // prettier-ignore
            "accept": "application/json",
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        }
      );
      setRepresentativeInfo(response?.data?.data?.results);
      setHasValueBefor(response?.data?.data?.results?.length);

      if (
        response?.status >= 200 &&
        response?.status < 400 &&
        response?.data?.data?.results !== 0
      ) {
        setIsLoadingContents(false);
        setIsLoading(false);
      } else if (
        response?.status >= 200 &&
        response?.status < 400 &&
        response?.data?.data?.results === 0
      ) {
        setIsLoadingContents(false);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoadingContents(false);
      setIsLoading(false);
    }
  };
  const onUpdate: SubmitHandler<IFormDataU> = async (data: IFormDataU) => {
    setIsLoading(true);

    const birthDate = new Date(data.birth_date);

    const timeZoneOffset = birthDate?.getTimezoneOffset() * 60000;

    const adjustedDate = new Date(birthDate?.getTime() - timeZoneOffset);

    const adjustedDateString = adjustedDate?.toISOString()?.split("T")[0];

    const birthDate_2 = new Date(data.birth_date_2);

    const timeZoneOffset_2 = birthDate_2?.getTimezoneOffset() * 60000;

    const adjustedDate_2 = new Date(birthDate_2?.getTime() - timeZoneOffset_2);

    const adjustedDateString_2 = adjustedDate_2?.toISOString()?.split("T")[0];

    if (representativeInfo && representativeIndex !== undefined) {
      const formattedData = JSON.stringify({
        phone_number:
          representativeIndex === 0 ? data.phone_number : data.phone_number_2,
        national_id:
          representativeIndex === 0 ? data.national_id : data.national_id_2,
        first_name:
          representativeIndex === 0 ? data.first_name : data.first_name_2,
        last_name:
          representativeIndex === 0 ? data.last_name : data.last_name_2,
        relation: representativeIndex === 0 ? data.relation : data.relation_2,
        birth_date:
          representativeIndex === 0
            ? data?.birth_date instanceof Date
              ? adjustedDateString
              : adjustedDateString
            : data?.birth_date_2 instanceof Date
            ? adjustedDateString_2
            : adjustedDateString_2,
      });

      try {
        const response = await axiosPrivate.put(
          USER_UPDATE_REPRESENTATIVE_INFO(
            representativeInfo?.[representativeIndex].representative_uid
          ),
          formattedData,
          {
            headers: {
              // prettier-ignore
              "accept": "application/json",
              // prettier-ignore
              "Authorization": `Bearer ${access_token}`,
            },
            withCredentials: true,
          }
        );
        // setFormNo(formNo + 1);

        if (
          response?.status >= 200 &&
          response?.status < 400 &&
          response?.data?.data?.results?.length !== 0
        ) {
          setRepresentativeInfo([
            {
              phone_number: representativeInfo[0].phone_number,
              national_id: representativeInfo[0].national_id,
              birth_date: representativeInfo[0].birth_date?.replace(/\//g, "-"),
              first_name: representativeInfo[0].first_name,
              last_name: representativeInfo[0].last_name,
              relation: data.relation,
            },
            {
              phone_number: representativeInfo[1].phone_number,
              national_id: representativeInfo[1].national_id,
              birth_date: representativeInfo[1].birth_date?.replace(/\//g, "-"),
              first_name: representativeInfo[1].first_name,
              last_name: representativeInfo[1].last_name,
              relation: data.relation_2,
            },
          ]);
          setEditMode(false);
          setRepresentativeIndex(undefined);
          setIsLoading(false);
          localStorage.setItem("user_state", "VERIFIED");
        } else {
          representativeInfo(undefined);

          console.error(
            "ERROR in acceptRules:",
            response.data || response.statusText
          );
        }
      } catch (error) {
        representativeInfo(undefined);

        setEditMode(false);
        setRepresentativeIndex(undefined);
        setIsLoading(false);
        console.error("An unexpected error occurred:", error);
      }
    } else {
      setRepresentativeIndex(undefined);
      representativeInfo(undefined);

      setEditMode(false);
      // setFormNo(formNo + 1);
    }
    setIsLoading(false);
  };

  const onSubmit: SubmitHandler<IFormDataU> = async (data: IFormDataU) => {
    const birthDate = new Date(data.birth_date);

    const timeZoneOffset = birthDate.getTimezoneOffset() * 60000;

    const adjustedDate = new Date(birthDate.getTime() - timeZoneOffset);

    const adjustedDateString = adjustedDate.toISOString().split("T")[0];

    const birthDate2 = new Date(data.birth_date_2);

    const timeZoneOffset2 = birthDate2.getTimezoneOffset() * 60000;

    const adjustedDate2 = new Date(birthDate2.getTime() - timeZoneOffset2);

    const adjustedDateString2 = adjustedDate2.toISOString().split("T")[0];

    setIsLoading(true);
    if (!representativeInfo || representativeInfo.length === 0) {
      const formattedData = JSON.stringify({
        representatives: [
          {
            phone_number: data.phone_number,
            national_id: data.national_id,

            birth_date:
              data?.birth_date instanceof Date
                ? adjustedDateString
                : adjustedDateString,

            first_name: data.first_name,
            last_name: data.last_name,
            relation: data.relation,
          },
          {
            phone_number: data.phone_number_2,
            national_id: data.national_id_2,

            birth_date:
              data?.birth_date_2 instanceof Date
                ? adjustedDateString2
                : adjustedDateString2,

            first_name: data.first_name_2,
            last_name: data.last_name_2,
            relation: data.relation_2,
          },
        ],
      });

      try {
        const response = await axiosPrivate.post(
          FILL_REPRESENTATIVE_INFO,
          formattedData,
          {
            headers: {
              // prettier-ignore
              "accept": "application/json",
              // prettier-ignore
              "Authorization": `Bearer ${access_token}`,
            },
            withCredentials: true,
          }
        );
        if (response?.status >= 200 && response?.status < 400) {
          setFormNo(formNo + 1);
          localStorage.setItem("user_state", "VERIFIED");
          setIsLoading(false);
        } else {
          console.error(
            "ERROR in acceptRules:",
            response.data || response.statusText
          );
        }
      } catch (error) {
        setIsLoading(false);
        console.error("An unexpected error occurred:", error);
      }
    } else {
      setFormNo(formNo + 1);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getRepresentativeInfo();
  }, []);

  useEffect(() => {
    setValue("first_name", representativeInfo?.[0]?.first_name);
    setValue("last_name", representativeInfo?.[0]?.last_name);
    setValue("phone_number", representativeInfo?.[0]?.phone_number);
    setValue("national_id", representativeInfo?.[0]?.national_id);
    setValue(
      "birth_date",
      representativeInfo?.[0]?.birth_date?.replace(/\//g, "-")
    );
    setValue("relation", representativeInfo?.[0]?.relation);
    setValue("first_name_2", representativeInfo?.[1]?.first_name);
    setValue("last_name_2", representativeInfo?.[1]?.last_name);
    setValue("phone_number_2", representativeInfo?.[1]?.phone_number);
    setValue("national_id_2", representativeInfo?.[1]?.national_id);
    setValue(
      "birth_date_2",
      representativeInfo?.[1]?.birth_date?.replace(/\//g, "-")
    );

    setValue("relation_2", representativeInfo?.[1]?.relation);
  }, [setValue, representativeInfo]);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    renderer: "svg",
  };

  const notificationsMessages = [
    {
      id: 1,
      message:
        "بدلیل اعتبارسنجی، دقت فرمایید که شماره همراه معرف متعلق به خود ایشان باشد.",
    },
    {
      id: 2,
      message:
        "معرف به معنی ضامن وام نمی‌باشد و صرفا در مواقعی که ارتباط گرفتن با شما امکان‌پذیر نباشد، کاربرد دارد.",
    },
  ];

  return (
    <>
      {isLoadingContents ? (
        <>
          <div className="flex  gap-8 basis-3/4 rounded-md md:ml-8 ml-2 shadow-md">
            <div className=" full-screen">
              <Lottie options={defaultOptions} height={100} width={100} />
            </div>
          </div>
        </>
      ) : (
        <motion.form
          variants={childVariants}
          initial="initial"
          animate="final"
          onSubmit={handleSubmit(editMode ? onUpdate : onSubmit)}
          className="flex flex-col flex-1 gap-12  rounded-md shadow-md  "
        >
          <NotifAccordionComponent
            notificationsMessages={notificationsMessages}
            mainNote="پیش از تکمیل فرم موارد ذیل را مطالعه فرمایید"
          />

          <div className="lg:flex flex-1 lg:flex-auto gap-12 justify-between rounded-md shadow-md  ">
            <div className=" mb-4 flex flex-col gap-2 w-full">
              {/* <div className=" w-[364px] ml-[80px]"> */}
              <div className="flex items-center gap-5">
                <label className="text-Title/16/Bold mb-[6px]">معرف اول</label>
                <ButtonComponent
                  className={`${
                    editMode || hasValueBefor === 0 ? ` invisible ` : ``
                  }`}
                  onClick={() => {
                    setEditMode(true);
                    setRepresentativeIndex(0);
                  }}
                  variant={"outlined"}
                  hasIcon
                  icon={<img src="/icons/edit-outline.svg" alt="edit icon" />}
                >
                  ویرایش
                </ButtonComponent>
              </div>
              <InputComponent
                defaultValue={representativeInfo?.[0]?.first_name}
                size="regular"
                isRequired
                disabled={representativeInfo?.[0] && representativeIndex !== 0}
                label="نام "
                name="first_name"
                control={control}
                errors={errors?.first_name}
                svgIcon={
                  <img
                    src="/icons/user-outline.svg"
                    alt="phone icon"
                    width={16}
                  />
                }
              />
              <InputComponent
                defaultValue={representativeInfo?.[0]?.last_name}
                disabled={representativeInfo?.[0] && representativeIndex !== 0}
                size="regular"
                isRequired
                label="نام خانوادگی "
                name="last_name"
                control={control}
                errors={errors?.last_name}
                svgIcon={
                  <img
                    src="/icons/user-outline.svg"
                    alt="phone icon"
                    width={16}
                  />
                }
              />
              <InputComponent
                defaultValue={representativeInfo?.[0]?.national_id}
                disabled={representativeInfo?.[0] && representativeIndex !== 0}
                size="regular"
                isRequired
                label="کدملی "
                name="national_id"
                control={control}
                maxLength={10}
                errors={errors?.national_id}
                svgIcon={
                  <img
                    src="/icons/profile-card-outline.svg"
                    alt="phone icon"
                    width={16}
                  />
                }
                type="tel"
              />
              <>
                <Controller
                  control={control}
                  name="birth_date"
                  rules={{ required: true }}
                  render={({ field }) => {
                    return (
                      <LocalizationProvider
                        dateAdapter={AdapterDateFnsJalali}
                        dateFormats={{ monthShort: "MMMM" }}
                        localeText={{
                          fieldMonthPlaceholder: () => "ماه",
                          fieldDayPlaceholder: () => "روز",
                          fieldYearPlaceholder: () => "سال",
                        }}
                      >
                        <div className="flex flex-col gap-0 mt-1 mb-4">
                          <div className="flex">
                            <label className=" text-gray-900 text-Body-OneLine/14/Regular">
                              تاریخ تولد
                            </label>
                            {<span className="text-red-500">*</span>}
                          </div>

                          <DatePicker
                            // inputFormat="dd.MM.yyyy"
                            disabled={
                              representativeInfo?.[0] &&
                              representativeIndex !== 0
                            }
                            slots={{
                              openPickerIcon: CalenderIcon,
                            }}
                            disableFuture
                            value={
                              dataFromOcr?.birth_date
                                ? new Date(
                                    moment(
                                      dataFromOcr?.birth_date,
                                      "jYYYY-jMM-jDD"
                                    ).format("YYYY-MM-DD")
                                  )
                                : representativeInfo?.[0]?.birth_date
                                ? new Date(representativeInfo?.[0]?.birth_date)
                                : null
                            }
                            onChange={(date) => {
                              field.onChange(date);
                            }}
                            closeOnSelect={true}
                            slotProps={{
                              inputAdornment: {
                                position: "start",
                              },
                              // textField: {
                              //   inputProps: {
                              //     placeholder: "تاریخ تولد",
                              //   },
                              // },
                            }}
                            sx={{
                              svg: {
                                color: errors?.birth_date ? "#B91C1C" : "",
                              },
                              width: "100%",
                              "& .MuiOutlinedInput-root": {
                                height: "44px",
                                border: "none",
                                borderRadius: "0.5rem",
                              },
                              "& .MuiDialogActions-root": {
                                bgcolor: "#F9FAFB !important",
                              },
                              "& .MuiInputBase-root.Mui-focused": {
                                bgcolor: "#F9FAFB !important",
                              },
                              "& .MuiInputBase-root": {
                                bgcolor: errors?.birth_date
                                  ? "#FEE2E2"
                                  : "#F9FAFB !important",
                              },
                              "& MuiInputBase-root-MuiOutlinedInput-root": {
                                bgcolor: "red",
                              },
                            }}
                            className={`mb-0 ${
                              errors?.birth_date ? "border-date-error " : ""
                            } `}
                            defaultValue={
                              representativeInfo?.[0]?.birth_date
                                ? new Date(
                                    moment(
                                      representativeInfo?.[0]?.birth_date,
                                      "jYYYY-jMM-jDD"
                                    ).format("YYYY-MM-DD")
                                  )
                                : null
                            }
                            views={["year", "month", "day"]}
                            openTo="year"
                            // disabled={
                            //   representativeInfo?.[0]?.birth_date ? true : false
                            // }
                          />
                          {errors?.birth_date ? (
                            <p
                              className={`text-Body-OneLine/14/Regular text-red-600`}
                            >
                              وارد کردن این مقدار الزامی است
                            </p>
                          ) : (
                            <div
                              className={`"flex items-center justify-center text-Body-OneLine/14/Regular text-gray-500"`}
                            ></div>
                          )}
                        </div>
                      </LocalizationProvider>
                    );
                  }}
                />
              </>

              <InputComponent
                defaultValue={representativeInfo?.[0]?.phone_number}
                disabled={representativeInfo?.[0] && representativeIndex !== 0}
                size="regular"
                isRequired
                maxLength={11}
                label="شماره موبایل "
                name="phone_number"
                control={control}
                errors={errors?.phone_number}
                svgIcon={
                  <img
                    src="/icons/phone-outline.svg"
                    alt="phone icon"
                    width={16}
                  />
                }
              />
              <ControlledSelectElement
                getValue={getValues}
                disabled={representativeInfo?.[0] && representativeIndex !== 0}
                APIgetValue={
                  representativeInfo?.[0]
                    ? relationList[
                        relationList?.findIndex(
                          (obj: any) =>
                            obj["relation"] === representativeInfo?.[0].relation
                        )
                      ]["name"]
                    : undefined
                }
                update={editMode}
                label="نسبت معرف"
                options={relationList}
                isRequired
                getOptionLabel={(item: any) => item.name}
                control={control}
                name="relation"
                errors={errors?.relation}
                showNonOption
                defaultSelectValue="نسبت معرف خود را انتخاب کنید"
                mode="multiSelect"
                setValue={setValue}
              />
              {/* </div> */}
            </div>
            <div className=" mb-4 flex flex-col gap-2 h-[630px]  w-full">
              <div className="flex items-center gap-5">
                <label className="text-Title/16/Bold mb-[6px] mt-5 md:mt-0">
                  معرف دوم
                </label>
                <ButtonComponent
                  className={`${
                    editMode || hasValueBefor === 0 ? ` invisible ` : ``
                  }`}
                  onClick={() => {
                    setEditMode(true);
                    setRepresentativeIndex(1);
                  }}
                  variant={"outlined"}
                  hasIcon
                  icon={<img src="/icons/edit-outline.svg" alt="edit icon" />}
                >
                  ویرایش
                </ButtonComponent>
              </div>
              <InputComponent
                disabled={representativeInfo?.[1] && representativeIndex !== 1}
                defaultValue={representativeInfo?.[1]?.first_name}
                size="regular"
                isRequired
                label="نام "
                name="first_name_2"
                control={control}
                errors={errors?.first_name_2}
                svgIcon={
                  <img
                    src="/icons/user-outline.svg"
                    alt="phone icon"
                    width={16}
                  />
                }
              />
              <InputComponent
                disabled={representativeInfo?.[1] && representativeIndex !== 1}
                defaultValue={representativeInfo?.[1]?.last_name}
                size="regular"
                isRequired
                label="نام خانوادگی "
                name="last_name_2"
                control={control}
                errors={errors?.last_name_2}
                svgIcon={
                  <img
                    src="/icons/user-outline.svg"
                    alt="phone icon"
                    width={16}
                  />
                }
              />
              <InputComponent
                disabled={representativeInfo?.[1] && representativeIndex !== 1}
                defaultValue={representativeInfo?.[1]?.national_id}
                size="regular"
                isRequired
                label="کدملی "
                name="national_id_2"
                maxLength={10}
                control={control}
                errors={errors?.national_id_2}
                svgIcon={
                  <img
                    src="/icons/profile-card-outline.svg"
                    alt="phone icon"
                    width={16}
                  />
                }
                type="tel"
              />

              <>
                <Controller
                  control={control}
                  name="birth_date_2"
                  rules={{ required: true }}
                  render={({ field }) => {
                    return (
                      <LocalizationProvider
                        dateAdapter={AdapterDateFnsJalali}
                        dateFormats={{ monthShort: "MMMM" }}
                        localeText={{
                          fieldMonthPlaceholder: () => "ماه",
                          fieldDayPlaceholder: () => "روز",
                          fieldYearPlaceholder: () => "سال",
                        }}
                      >
                        <div className="flex flex-col gap-0 mt-1 mb-4">
                          <div className="flex">
                            <label className=" text-gray-900 text-Body-OneLine/14/Regular">
                              تاریخ تولد
                            </label>
                            {<span className="text-red-500">*</span>}
                          </div>

                          <DatePicker
                            // inputFormat="dd.MM.yyyy"
                            disabled={
                              representativeInfo?.[1] &&
                              representativeIndex !== 1
                            }
                            slots={{
                              openPickerIcon: CalenderIcon,
                            }}
                            disableFuture
                            value={
                              dataFromOcr?.birth_date_2
                                ? new Date(
                                    moment(
                                      dataFromOcr?.birth_date_2,
                                      "jYYYY-jMM-jDD"
                                    ).format("YYYY-MM-DD")
                                  )
                                : representativeInfo?.[1]?.birth_date
                                ? new Date(representativeInfo?.[1]?.birth_date)
                                : null
                            }
                            onChange={(date) => {
                              field.onChange(date);
                            }}
                            closeOnSelect={true}
                            slotProps={{
                              inputAdornment: {
                                position: "start",
                              },
                              // textField: {
                              //   inputProps: {
                              //     placeholder: "تاریخ تولد",
                              //   },
                              // },
                            }}
                            sx={{
                              svg: {
                                color: errors?.birth_date_2 ? "#B91C1C" : "",
                              },
                              width: "100%",
                              "& .MuiOutlinedInput-root": {
                                height: "44px",
                                border: "none",
                                borderRadius: "0.5rem",
                              },
                              "& .MuiDialogActions-root": {
                                bgcolor: "#F9FAFB !important",
                              },
                              "& .MuiInputBase-root.Mui-focused": {
                                bgcolor: "#F9FAFB !important",
                              },
                              "& .MuiInputBase-root": {
                                bgcolor: errors?.birth_date_2
                                  ? "#FEE2E2"
                                  : "#F9FAFB !important",
                              },
                              "& MuiInputBase-root-MuiOutlinedInput-root": {
                                bgcolor: "red",
                              },
                            }}
                            className={`mb-0 ${
                              errors?.birth_date_2 ? "border-date-error " : ""
                            } `}
                            defaultValue={
                              representativeInfo?.[1]?.birth_date
                                ? new Date(
                                    moment(
                                      representativeInfo?.[1]?.birth_date,
                                      "jYYYY-jMM-jDD"
                                    ).format("YYYY-MM-DD")
                                  )
                                : null
                            }
                            views={["year", "month", "day"]}
                            openTo="year"
                            // disabled={
                            //   representativeInfo?.[1]?.birth_date ? true : false
                            // }
                          />
                          {errors?.birth_date_2 ? (
                            <p
                              className={`text-Body-OneLine/14/Regular text-red-600`}
                            >
                              وارد کردن این مقدار الزامی است
                            </p>
                          ) : (
                            <div
                              className={`"flex items-center justify-center text-Body-OneLine/14/Regular text-gray-500"`}
                            ></div>
                          )}
                        </div>
                      </LocalizationProvider>
                    );
                  }}
                />
              </>

              <InputComponent
                disabled={representativeInfo?.[1] && representativeIndex !== 1}
                defaultValue={representativeInfo?.[1]?.phone_number}
                size="regular"
                isRequired
                label="شماره موبایل "
                maxLength={11}
                name="phone_number_2"
                control={control}
                errors={errors?.phone_number_2}
                svgIcon={
                  <img
                    src="/icons/phone-outline.svg"
                    alt="phone icon"
                    width={16}
                  />
                }
              />
              <ControlledSelectElement
                getValue={getValues}
                disabled={representativeInfo?.[1] && representativeIndex !== 1}
                APIgetValue={
                  representativeInfo?.[1]
                    ? relationList_2[
                        relationList_2?.findIndex(
                          (obj: any) =>
                            obj["relation_2"] ===
                            representativeInfo?.[1].relation
                        )
                      ]["name"]
                    : undefined
                }
                update={editMode}
                label="نسبت معرف"
                options={relationList_2}
                isRequired
                getOptionLabel={(item: any) => item.name}
                control={control}
                name="relation_2"
                errors={errors?.relation_2}
                showNonOption
                defaultSelectValue="نسبت معرف خود را انتخاب کنید"
                mode="multiSelect"
                setValue={setValue}
              />
            </div>
          </div>
          <div className="flex w-full justify-center gap-1 pb-4 sticky bottom-0 bg-white right-0 left-0">
            {editMode ? (
              <>
                <ButtonComponent
                  className="mt-1 w-[120px] h-10"
                  variant="outlined"
                  onClick={() => {
                    setEditMode(false);
                    setRepresentativeIndex(undefined);
                    setIsLoading(false);
                  }}
                >
                  لغو
                </ButtonComponent>
              </>
            ) : (
              <>
                <ButtonComponent
                  className="mt-1 w-[120px] h-10"
                  variant="outlined"
                  onClick={() => setFormNo(formNo - 1)}
                >
                  بازگشت
                </ButtonComponent>
              </>
            )}
            {editMode ? (
              <>
                <ButtonComponent
                  isClicked={isLoading}
                  disabled={isLoading}
                  type="submit"
                  className="mt-1 w-[120px] h-10 mr-[8px]"
                  variant="filled"
                >
                  تایید
                </ButtonComponent>
              </>
            ) : (
              <>
                <ButtonComponent
                  isClicked={isLoading}
                  disabled={isLoading}
                  type="submit"
                  className="mt-1 w-[120px] h-10 mr-[8px]"
                  variant="filled"
                >
                  ادامه
                </ButtonComponent>
              </>
            )}
          </div>
        </motion.form>
      )}
    </>
  );
}

export default UserFormStep4;
